<template>
    <div class="row bg-brand-darkest-grey" style="height: 40px">
        <div
            class="col-6 text-white align-self-center"
            style="text-align: center"
        >
            <span>
                &copy;
                {{ t('General.CrefoCopyright', { year: getCurrentYear }) }}
            </span>
        </div>
        <div
            class="col-6 text-white align-self-center"
            style="text-align: center"
        >
            <span>
                <a
                    href="javascript:UC_UI.showSecondLayer()"
                    class="text-white"
                    data-qa="cookie-settings-link"
                >{{ t('Navigation.CookieConsentSettings') }}</a
                >
                &nbsp; | &nbsp;
                <a
                    href="https://www.creditreform.de/ueber-uns/impressum.html"
                    target="_blank"
                    class="text-white"
                    data-qa="legal-notice-link"
                    rel="noopener"
                >{{ t('Navigation.Impressum') }}</a
                >
            </span>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()
const getCurrentYear = computed(() => new Date().getFullYear())
</script>
